import { BaseApiTemplateService } from "../shared/base-api-template-service.model";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Core2Config } from "../shared/core2Config";
import { ApiVisa } from '../shared';
import { ApiResponseModel } from '../shared/api-response.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: "root" })
export class WmsGrnProcessingQueueService extends BaseApiTemplateService<any> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "wms-grn-processing-queues/backoffice-ep";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "wms-grn-processing-queues/backoffice-ep";
    this.httpClient = http;
  }

  public insertToGrnProcessingQueue(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/insert-to-queue';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
  
  public insertBundledGrnProcessingQueue(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url +  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "wms-grn-processing-queues/bundled-items-insert/backoffice-ep";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public updateGrnProcessingQueue(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/update-queue';
    }
    return this.httpClient.put<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public getByCriteriaPost(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/query';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

   public deleteProcessingQueueAndContainers(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url +  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "wms-grn-processing-queues/delete-queue-and-containers/backoffice-ep";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public bulkContainerQtyFromProcessingQueue(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url +  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "wms-grn-processing-queues/bulk-update-container-qty/backoffice-ep";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
